import Global_md from "../../../assets/icons/Global_md";
import Help_md from "../../../assets/icons/Help_md";
import Bell_md from "../../../assets/icons/Bell_md";
import Search_sm from "../../../assets/icons/Search_sm";
import ClearDelete from "../../../assets/icons/ClearDelete";
import Check from "../../../assets/icons/Check";
import HoldingHands from "../../../assets/icons/HoldingHands";
import Gear from "../../../assets/icons/Gear";
import Clipboard from "../../../assets/icons/Clipboard";
import Car from "../../../assets/icons/Car";
import QualityGood from "../../../assets/icons/quality/QualityGood";
import QualityBad from "../../../assets/icons/quality/QualityBad";
import QualityCircle from "../../../assets/icons/quality/QualityCircle";
import Transports from "../../../assets/icons/Transports";
import MobileSignal from "../../../assets/icons/MobileSignal";
import Trash from "../../../assets/icons/Trash";
import Parking from "../../../assets/icons/Parking";
import Lamp from "../../../assets/icons/Lamp";
import Medical from "../../../assets/icons/Medical";
import Bolt from "../../../assets/icons/Bolt";
import WaterDrop from "../../../assets/icons/WaterDrop";
import BrandLogo from "../../../assets/brandLogo/BrandLogo";
import Environment from "../../../assets/icons/Environment";
import Dot from '../../../assets/icons/Dot';
import PublicSpace from '../../../assets/icons/PublicSpace';

import AwfulSmile from "../../../assets/icons/smiles/AwfulSmile";
import BadSmile from "../../../assets/icons/smiles/BadSmile";
import OkSmile from "../../../assets/icons/smiles/OkSmile";
import GoodSmile from "../../../assets/icons/smiles/GoodSmile";
import GreatSmile from "../../../assets/icons/smiles/GreatSmile";

import fewclouds from "../../../assets/icons/weather/Clouds";
import clearsky from "../../../assets/icons/weather/Sun";
import Rain from "../../../assets/icons/weather/Rain";
import clearnightsky from '../../../assets/icons/weather/Moon';
import Clouds from "../../../assets/icons/weather/Clouds";
import Clear from "../../../assets/icons/weather/Sun";

export {
  Global_md,
  Help_md,
  Bell_md,
  Search_sm,
  ClearDelete,
  Check,
  HoldingHands,
  AwfulSmile,
  BadSmile,
  OkSmile,
  GoodSmile,
  GreatSmile,
  Gear,
  Clipboard,
  Car,
  QualityGood,
  QualityBad,
  QualityCircle,
  Transports,
  MobileSignal,
  Trash,
  Parking,
  Lamp,
  Medical,
  Bolt,
  WaterDrop,
  BrandLogo,
  Environment,
  Dot,
  PublicSpace,

  clearsky,
  fewclouds,
  Rain,
  clearnightsky,
  Clouds,
  Clear
}